import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

const EmptyState = ({ icon: Icon, message }) => {
  return (
    <Box
      data-testid="empty-state"
      sx={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {Icon && (
        <Box data-testid="empty-state-icon">
          <Icon />
        </Box>
      )}
      <Box
        data-testid="empty-state-message"
        sx={{
          color: "#5A6C87",
          fontSize: "13px",
          lineHeight: "20px",
          fontWeight: "semi-bold",
          fontFamily: "Manrope",
        }}
      >
        {message}
      </Box>
    </Box>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  message: PropTypes.string.isRequired,
};

export default EmptyState;
